
import { computed, defineComponent } from 'vue';
import { IRastreabilidadeLote } from '@/models/Entidades/Estoques/IRastreabilidade';
import SelecionarData from '@/core/components/Tela/SelecionarData.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';

export default defineComponent({
  name: 'LancamentoRastreabilidadeLote',
  props: {
    rastreabilidadeLote: {
      type: Object as () => IRastreabilidadeLote,
      required: true,
    },
    qtdRastreabilidade: {
      type: Number,
      default: 0,
    },
    qtdCasasDecimais: {
      type: Number,
      default: 2,
    },
  },
  components: {
    SelecionarData,
    CampoNumerico,
  },
  emits: ['update:rastreabilidadeLote', 'update:qtdrastreabilidade'],
  setup(props, { emit }) {
    const computedRastreabilidadeLote = computed({
      get: () => props.rastreabilidadeLote,
      set: (valor: IRastreabilidadeLote) => {
        emit('update:rastreabilidadeLote', valor);
      },
    });

    const computedQtdRastreabilidade = computed({
      get: () => props.qtdRastreabilidade,
      set: (valor: number) => {
        emit('update:qtdrastreabilidade', valor);
      },
    });

    return {
      props,
      computedRastreabilidadeLote,
      computedQtdRastreabilidade,
    };
  },
});
